import { useSettingsState } from "@/context/SettingsStateContext";
import { useEffect } from "react";
import { toast } from "sonner";
import { defaultFormatTemplate } from "@/data/email";
import { useSettings } from "@/context/SettingsContext";

export default function useSettingTemplate() {
  const { htmlTemplate, setHtmlTemplate } = useSettingsState();
  const { formattemplate, setformattemplate, isLoading: settingsLoading } = useSettings();

  // Clean up the handleSaveTemplate function
  const handleSaveTemplate = () => {
    try {
      console.log("Saving WordPress template from editor");
      setformattemplate(htmlTemplate);
      toast.success("WordPress template saved successfully");
    } catch (error) {
      console.error("Error saving WordPress HTML template:", error);
      toast.error("Failed to save WordPress template. Please try again.");
    }
  };

  // Add function to handle restoring the default template
  const handleRestoreDefaultTemplate = () => {
    // Set the template back to default
    setHtmlTemplate(defaultFormatTemplate);
    toast.info("Default WordPress template restored");
  };

  // Add a useEffect to reset htmlTemplate to a clean version when component mounts
  useEffect(() => {
    // Set a clean WordPress template without title, author, date, categories
    const cleanTemplate = `<div class="entry-content">
      <!-- Content will be inserted here -->
    </div>`;

    // Only set if the current template has the entry-title in it
    if (
      htmlTemplate &&
      (htmlTemplate.includes("entry-title") ||
        htmlTemplate.includes("Post Title Goes Here"))
    ) {
      console.log("Setting clean WordPress template without title/author/date elements");
      console.log(
        "Using default WordPress template:",
        defaultFormatTemplate.substring(0, 50) + "..."
      );
      setHtmlTemplate(defaultFormatTemplate);

      if (!settingsLoading && formattemplate && formattemplate.includes("entry-title")) {
        setformattemplate(defaultFormatTemplate);
      }
    }
  }, [htmlTemplate, formattemplate, settingsLoading]);

  return {
    handleSaveTemplate,
    handleRestoreDefaultTemplate,
  };
}
